import type { ISingleCartItem } from "@src/types/AppTypes";
import { createContext } from "react";

export const CartContext = createContext<{
  cart: ISingleCartItem[];
  setCartItems: React.Dispatch<{
    payload: ISingleCartItem[];
    type: "updateCart";
  }>;
}>({ cart: [], setCartItems: () => {} });

export function cartReducer(
  state: ISingleCartItem[],
  action: { payload: ISingleCartItem[]; type: "updateCart" }
) {
  if (action.type === "updateCart") {
    return action.payload;
  } else {
    return state;
  }
}

// for storing guest user cart id
export const CartIdContext = createContext<{
  cartId: number;
  setCartId: React.Dispatch<{
    payload: number;
    type: "guestUserCartId" | "loginUserCartId";
  }>;
}>({ cartId: 0, setCartId: () => {} });

export function cartIdReducer(
  state: number,
  action: { payload: number; type: "guestUserCartId" }
) {
  if (action.type === "guestUserCartId") {
    return action.payload;
  } else if (action.type === "loginUserCartId") {
    return action.payload;
  }
  {
    return state;
  }
}
